import React from "react";
import GridContainer from "./../Grid/GridContainer";
import GridItem from "./../Grid/GridItem";
import CardGenerico from "./components/CardGenerico";
import { format, startOfMonth, subMonths, addMonths } from "date-fns";
export default function ChartReceitas({ periodo, tipoPedido }) {
  const filter = `${
    periodo.dataInicial ? `/${periodo.dataInicial}/${periodo.dataFinal}` : ""
  }/${tipoPedido}`;
  const start = startOfMonth(subMonths(new Date(), 1));
  const end = startOfMonth(addMonths(new Date(), 1));
  const formatAndEncode = (date) =>
    encodeURIComponent(format(date, "yyyy-MM-dd HH:mm:ss"));
  const range = `${formatAndEncode(start)}/${formatAndEncode(end)}`;
  const charts = [
    {
      nameChart: "receitaAcumulada",
      title: "Receitas acumuladas do mês atual comparadas com o mês anterior",
      url: `/dashboard/chart/ACUMULADO_DIA/${range}/${tipoPedido}`,
    },
    {
      nameChart: "numVendas",
      title: "Vendas por dia",
      url: `/dashboard/chart/QUANTIDADE_PEDIDO_DIA${filter}`,
    },
    {
      nameChart: "receitaPorDiaDaSemana",
      title: "Vendas por dia da semana",
      url: `/dashboard/chart/VALOR_TOTAL_PEDIDO_DIA_DA_SEMANA${filter}`,
    },
    {
      nameChart: "receitaTipoPedido",
      title: "Vendas por tipo de pedido",
      url: `/dashboard/chart/VALOR_TOTAL_TIPO_PEDIDO${filter}`,
    },
    {
      nameChart: "valorItensMaisVendidos",
      title: "Ranking dos 15 de itens mais vendidos (valor)",
      url: `/dashboard/chart/VALOR_ITENS_MAIS_VENDIDOS${filter}`,
    },
    {
      nameChart: "quantItensMaisVendidos",
      title: "Ranking dos 15 itens mais vendidos (quantidade)",
      url: `/dashboard/chart/QUANTIDADE_ITENS_MAIS_VENDIDOS${filter}`,
    },
  ];

  return (
    <GridContainer>
      {charts.map(({ nameChart, title, url }, index) => (
        <GridItem
          key={index}
          size={{
            xs: 12,
            sm: 12,
            md: ["receitaPorDiaDaSemana", "receitaTipoPedido"].includes(
              nameChart
            )
              ? 6
              : 12,
          }}
        >
          <CardGenerico nameChart={nameChart} title={title} url={url} />
        </GridItem>
      ))}
    </GridContainer>
  );
}
